import {
    ADDUPDATESUBADMINMGMT_SUCCESS,
    ADDUPDATESUBADMINMGMT_FAILED,
    RESET_ADDUPDATESUBADMINMGMT,
    LOADING_ADDUPDATESUBADMINMGMT,
    NETWORK_ERROR_ADDUPDATESUBADMINMGMT,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDUPDATESUBADMINMGMT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADDUPDATESUBADMINMGMT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADDUPDATESUBADMINMGMT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADDUPDATESUBADMINMGMT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADDUPDATESUBADMINMGMT:
            return (state = initialState);
        default:
            return state;
    }
};
